module.exports = __webpack_public_path__ + "static/img/9.8f1e612.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/9.png
// module id = W38A
// module chunks = 0